import comp from "./DynamicFieldsViewV2";
export default comp;
